/**
 * @deprecated Not a value remap: the sole consumer (`categoryService.getCategories`) only reads key
 * presence as an `isOldCategory` flag. Do not treat this as migration prior art for SI-8780.
 */
export const OLD_TO_NEW_CATEGORIES_MAP: Record<string, string> = {
    "Arts_and_Entertainment~Fashion_and_Modeling": "Lifestyle~Fashion_and_Apparel",
    "Books_and_Literature~Books_and_Literature": "Arts_and_Entertainment~Books_and_Literature",
    "Books_and_Literature~E-Books": "Arts_and_Entertainment~Books_and_Literature",
    "Computer_and_Electronics~Graphics_and_Multimedia_Tools":
        "Computers_Electronics_and_Technology~Graphics_Multimedia_and_Web_Design",
    "Computer_and_Electronics~Programming": "Computers_Electronics_and_Technology~Programming_and_Developer_Software",
    "Computer_and_Electronics~Software": "Computers_Electronics_and_Technology~Programming_and_Developer_Software",
    "Games~Online": "Games~Video_Games_Consoles_and_Accessories",
    "Games~Video_Games": "Games~Video_Games_Consoles_and_Accessories",
    "Home_and_Garden~Moving_and_Relocating": "Business_and_Consumer_Services~Relocation_and_Household_Moving",
    "Internet_and_Telecom~Domain_Names_and_Register":
        "Computers_Electronics_and_Technology~Web_Hosting_and_Domain_Names",
    "Internet_and_Telecom~Mobile_Developers": "Computers_Electronics_and_Technology~Programming_and_Developer_Software",
    "Internet_and_Telecom~Online_Marketing": "Business_and_Consumer_Services~Online_Marketing",
    "Internet_and_Telecom~Web_Hosting": "Computers_Electronics_and_Technology~Web_Hosting_and_Domain_Names",
    "News_and_Media~Magazines_and_E-Zines": "News_and_Media",
    "News_and_Media~News_and_Media": "News_and_Media",
    "News_and_Media~Newspapers": "News_and_Media",
    "Science~Biology": "Science_and_Education~Biology",
    "Science~Educational_Resources": "Science_and_Education~Education",
    "Shopping~Auctions": "E-commerce_and_Shopping~Auctions",
    "Shopping~Classifieds": "E-commerce_and_Shopping~Classifieds",
    "Shopping~Coupons": "E-commerce_and_Shopping~Coupons_and_Rebates",
    "Shopping~General_Merchandise": "E-commerce_and_Shopping~Marketplace",
    "Shopping~Shopping": "E-commerce_and_Shopping~E-commerce_and_Shopping",
    "Adult~Adult": "Adult",
    "Gambling~Sports": "Gambling~Sports_Betting",
    "Arts_and_Entertainment~Architecture": "Heavy_Industry_and_Engineering~Architecture",
    "Arts_and_Entertainment~Awards": "Arts_and_Entertainment~Arts_and_Entertainment",
    "Arts_and_Entertainment~Celebrities_and_Entertainment_News": "Arts_and_Entertainment~Arts_and_Entertainment",
    "Arts_and_Entertainment~Movies": "Arts_and_Entertainment~TV_Movies_and_Streaming",
    "Arts_and_Entertainment~Music_and_Audio": "Arts_and_Entertainment~Music",
    "Arts_and_Entertainment~Photography": "Hobbies_and_Leisure~Photography",
    "Arts_and_Entertainment~TV_and_Video": "Arts_and_Entertainment~TV_Movies_and_Streaming",
    "Autos_and_Vehicles~Automotive_Industry": "Vehicles~Automotive_Industry",
    "Autos_and_Vehicles~Automotive_News": "Vehicles~Vehicles",
    "Autos_and_Vehicles~Autos_and_Vehicles": "Vehicles~Vehicles",
    "Autos_and_Vehicles~Aviation": "Vehicles~Aviation",
    "Autos_and_Vehicles~Boating": "Vehicles~Boats",
    "Autos_and_Vehicles~Car_Rentals": "Travel_and_Tourism~Car_Rentals",
    "Autos_and_Vehicles~Makes_and_Models": "Vehicles~Makes_and_Models",
    "Autos_and_Vehicles~Motorcycles": "Vehicles~Motorcycles",
    "Autos_and_Vehicles~MotorSports": "Vehicles~MotorSports",
    "Autos_and_Vehicles~Trains_and_Railroads": "Travel_and_Tourism~Ground_Transportation",
    "Beauty_and_Fitness~Beauty": "Lifestyle~Beauty_and_Cosmetics",
    "Beauty_and_Fitness~Beauty_and_Fitness": "Lifestyle~Beauty_and_Cosmetics",
    "Beauty_and_Fitness~Cosmetics": "Lifestyle~Beauty_and_Cosmetics",
    "Beauty_and_Fitness~Fitness": "Health~Nutrition_and_Fitness",
    "Beauty_and_Fitness~Hair": "Lifestyle~Beauty_and_Cosmetics",
    "Beauty_and_Fitness~Skin_Care": "Lifestyle~Beauty_and_Cosmetics",
    "Beauty_and_Fitness~Weight_Loss": "Health~Nutrition_and_Fitness",
    Books_and_Literature: "Arts_and_Entertainment~Books_and_Literature",
    "Books_and_Literature~Folklore": "Science_and_Education~Literature",
    "Books_and_Literature~Guides_and_Reviews": "Science_and_Education~Literature",
    "Business_and_Industry~Aerospace_and_Defence": "Heavy_Industry_and_Engineering~Aerospace_and_Defense",
    "Business_and_Industry~Agriculture_and_Forestry": "Heavy_Industry_and_Engineering~Agriculture",
    "Business_and_Industry~Associations": "Law_and_Government~Law_and_Government",
    "Business_and_Industry~Biotechnology_and_Pharmaceuticals": "Health~Biotechnology_and_Pharmaceuticals",
    "Business_and_Industry~Business_Services": "Business_and_Consumer_Services~Business_Services",
    "Business_and_Industry~Chemicals": "Heavy_Industry_and_Engineering~Chemical_Industry",
    "Business_and_Industry~Construction_and_Maintenance": "Heavy_Industry_and_Engineering~Construction_and_Maintenance",
    "Business_and_Industry~Energy": "Heavy_Industry_and_Engineering~Energy_Industry",
    "Business_and_Industry~Marketing_and_Advertising": "Business_and_Consumer_Services~Marketing_and_Advertising",
    "Business_and_Industry~Metals_and_Mining": "Heavy_Industry_and_Engineering~Metals_and_Mining",
    "Business_and_Industry~Publishing_and_Printing": "Business_and_Consumer_Services~Publishing_and_Printing",
    "Business_and_Industry~Real_Estate": "Business_and_Consumer_Services~Real_Estate",
    "Business_and_Industry~Textiles_and_Nonwovens": "Business_and_Consumer_Services~Textiles",
    "Career_and_Education~Business_Training": "Science_and_Education~Business_Training",
    "Career_and_Education~Education": "Science_and_Education~Education",
    "Career_and_Education~Human_Resources": "Jobs_and_Career~Human_Resources",
    "Career_and_Education~Jobs_and_Employment": "Jobs_and_Career~Jobs_and_Employment",
    "Career_and_Education~Universities_and_Colleges": "Science_and_Education~Colleges_and_Universities",
    "Computer_and_Electronics~Computer_and_Electronics":
        "Computers_Electronics_and_Technology~Computers_Electronics_and_Technology",
    "Computer_and_Electronics~Computer_Hardware": "Computers_Electronics_and_Technology~Computer_Hardware",
    "Computer_and_Electronics~Computer_Security": "Computers_Electronics_and_Technology~Computer_Security",
    "Computer_and_Electronics~Consumer_Electronics": "Computers_Electronics_and_Technology~Consumer_Electronics",
    "Computer_and_Electronics~Networking": "Computers_Electronics_and_Technology~Computers_Electronics_and_Technology",
    "Finance~Accounting": "Finance~Accounting_and_Auditing",
    "Finance~Banking": "Finance~Banking_Credit_and_Lending",
    "Finance~Credit,_Loans_and_Mortgages": "Finance~Banking_Credit_and_Lending",
    "Finance~Financial_Management": "Finance~Financial_Planning_and_Management",
    "Finance~Grants_and_Scholarships": "Science_and_Education~Grants_Scholarships_and_Financial_Aid",
    "Food_and_Drink~Catering": "Food_and_Drink~Restaurants_and_Delivery",
    "Food_and_Drink~Food_and_Grocery_Retailers": "Food_and_Drink~Groceries",
    "Gambling~Regulation_and_Organizations": "Law_and_Government~Government",
    "Games~Roleplaying": "Games~Roleplaying_Games",
    "Health~Child_Health": "Health~Childrens_Health",
    "Health~Conditions_and_Diseases": "Health~Health_Conditions_and_Concerns",
    "Health~Dentistry": "Health~Dentist_and_Dental_Services",
    "Health~Healthcare_Industry": "Health~Health",
    "Health~Nutrition": "Health~Nutrition_Diets_and_Fitness",
    "Health~Nutrition_and_Fitness": "Health~Nutrition_Diets_and_Fitness",
    "Health~Products_and_Shopping": "Health~Health",
    "Health~Reproductive_Health": "Health~Womens_Health",
    "Health~Senior_Health": "Health~Geriatric_and_Aging_Care",
    "Home_and_Garden~Home_Improvement": "Home_and_Garden~Home_Improvement_and_Maintenance",
    "Home_and_Garden~Interior_Decor": "Home_and_Garden~Interior_Design",
    "Internet_and_Telecom~Ad_Network": "Computers_Electronics_and_Technology~Advertising_Networks",
    "Internet_and_Telecom~Chats_and_Forums":
        "Computers_Electronics_and_Technology~Social_Networks_and_Online_Communities",
    "Internet_and_Telecom~Email": "Computers_Electronics_and_Technology~Email",
    "Internet_and_Telecom~File_Sharing": "Computers_Electronics_and_Technology~File_Sharing_and_Hosting",
    "Internet_and_Telecom~Internet_and_Telecom":
        "Computers_Electronics_and_Technology~Computers_Electronics_and_Technology",
    "Internet_and_Telecom~Search_Engine": "Computers_Electronics_and_Technology~Search_Engines",
    "Internet_and_Telecom~Social_Network":
        "Computers_Electronics_and_Technology~Social_Networks_and_Online_Communities",
    "Internet_and_Telecom~Telecommunications": "Computers_Electronics_and_Technology~Telecommunications",
    "Internet_and_Telecom~Web_Design": "Computers_Electronics_and_Technology~Graphics_Multimedia_and_Web_Design",
    "Law_and_Government~Law": "Law_and_Government~Legal",
    "Law_and_Government~Military_and_Defense": "Law_and_Government~National_Security",
    "News_and_Media~College_and_University_Press": "Science_and_Education~Universities_and_Colleges",
    "News_and_Media~Sports_News": "Sports~Sports",
    "News_and_Media~Technology_News": "Computers_Electronics_and_Technology~Computers_Electronics_and_Technology",
    "News_and_Media~Weather": "Science_and_Education~Weather",
    "People_and_Society~Crime_and_Prosecution": "Law_and_Government~Law_Enforcement_and_Protective_Services",
    "People_and_Society~Death": "Community_and_Society~Decease",
    "People_and_Society~Disabled_and_Special_Needs": "Health~Developmental_and_Physical_Disabilities",
    "People_and_Society~Gay,_Lesbian,_and_Bisexual": "Community_and_Society~LGBTQ",
    "People_and_Society~Genealogy": "Hobbies_and_Leisure~Ancestry_and_Genealogy",
    "People_and_Society~History": "Science_and_Education~History",
    "People_and_Society~Holidays": "Community_and_Society~Holidays_and_Seasonal_Events",
    "People_and_Society~Philanthropy": "Community_and_Society~Philanthropy",
    "People_and_Society~Philosophy": "Science_and_Education~Philosophy",
    "People_and_Society~Relationships_and_Dating": "Community_and_Society~Romance_and_Relationships",
    "People_and_Society~Religion_and_Spirituality": "Community_and_Society~Faith_and_Beliefs",
    "Pets_and_Animals~Animal_Products_and_Service": "Pets_and_Animals~Pet_Food_and_Supplies",
    "Recreation_and_Hobbies~Antiques": "Hobbies_and_Leisure~Antiques_and_Collectibles",
    "Recreation_and_Hobbies~Camps": "Hobbies_and_Leisure~Camping_Scouting_and_Outdoors",
    "Recreation_and_Hobbies~Climbing": "Sports~Climbing",
    "Recreation_and_Hobbies~Collecting": "Hobbies_and_Leisure~Antiques_and_Collectibles",
    "Recreation_and_Hobbies~Crafts": "Hobbies_and_Leisure~Crafts",
    "Recreation_and_Hobbies~Models": "Hobbies_and_Leisure~Models",
    "Recreation_and_Hobbies~Outdoors": "Hobbies_and_Leisure~Camping_Scouting_and_Outdoors",
    "Recreation_and_Hobbies~Scouting": "Hobbies_and_Leisure~Camping_Scouting_and_Outdoors",
    "Recreation_and_Hobbies~Theme_Parks": "Travel_and_Tourism~Tourist_Attractions",
    "Recreation_and_Hobbies~Tobacco": "Lifestyle~Tobacco",
    "Recreation_and_Hobbies~Weapons": "Sports~Hunting_and_Shooting",
    "Reference~Archives": "Science_and_Education~Public_Records_and_Directories",
    "Reference~Dictionaries_and_Encyclopedias": "Reference_Materials~Dictionaries_and_Encyclopedias",
    "Reference~Directories": "Reference_Materials~Public_Records_and_Directories",
    "Reference~Libraries_and_Museums": "Science_and_Education~Libraries_and_Museums",
    "Reference~Maps": "Reference_Materials~Maps",
    "Reference~Reference": "Reference_Materials~Reference_Materials",
    "Science~Agriculture": "Heavy_Industry_and_Engineering~Agriculture",
    "Science~Astronomy": "Science_and_Education~Astronomy",
    "Science~Chemistry": "Science_and_Education~Chemistry",
    "Science~Earth_Sciences": "Science_and_Education~Earth_Sciences",
    "Science~Engineering_and_Technology": "Science_and_Education~Science_and_Education",
    "Science~Environment": "Science_and_Education~Environmental_Science",
    "Science~Math": "Science_and_Education~Math",
    "Science~Physics": "Science_and_Education~Physics",
    "Science~Science": "Science_and_Education~Science_and_Education",
    "Science~Social_Sciences": "Science_and_Education~Social_Sciences",
    "Science_and_Education~Colleges_and_Universities": "Science_and_Education~Universities_and_Colleges",
    "Shopping~Antiques_and_Collectibles": "Hobbies_and_Leisure~Antiques_and_Collectibles",
    "Shopping~Children": "Lifestyle~Childcare",
    "Shopping~Clothing": "Lifestyle~Fashion_and_Apparel",
    "Shopping~Consumer_Electronics": "Computers_Electronics_and_Technology~Consumer_Electronics",
    "Shopping~Flowers": "Lifestyle~Gifts_and_Flowers",
    "Shopping~Furniture": "Home_and_Garden~Furniture",
    "Shopping~Gifts": "Lifestyle~Gifts_and_Flowers",
    "Shopping~Home_and_Garden": "Home_and_Garden~Home_and_Garden",
    "Shopping~Jewelry": "Lifestyle~Jewelry_and_Luxury_Products",
    "Shopping~Music": "Arts_and_Entertainment~Music",
    "Shopping~Sports": "Sports~Sports",
    "Shopping~Weddings": "Lifestyle~Weddings",
    "Sports~Equestrian": "Pets_and_Animals~Horses",
    "Sports~Football": "Sports~American_Football",
    "Travel~Accommodation_and_Hotels": "Travel_and_Tourism~Accommodation_and_Hotels",
    "Travel~Airlines_and_Airports": "Travel_and_Tourism~Air_Travel",
    "Travel~Roads_and_Highways": "Travel_and_Tourism~Transportation_and_Excursions",
    "Travel~Tourism": "Travel_and_Tourism~Travel_and_Tourism",
    "Travel~Travel": "Travel_and_Tourism~Travel_and_Tourism",
    Shopping: "E-commerce_and_Shopping",
    Autos_and_Vehicles: "Vehicles~Vehicles",
    Beauty_and_Fitness: "Lifestyle~Beauty_and_Cosmetics",
    Internet_and_Telecom: "Computers_Electronics_and_Technology~Computers_Electronics_and_Technology",
    // "Pets_and_Animals": "Pets_and_Animals~Animals",
    Reference: "Reference_Materials~Reference_Materials",
    Science: "Science_and_Education~Science_and_Education",
    Travel: "Travel_and_Tourism~Travel_and_Tourism",
};
